<template>
    <div>

        <div v-if="!gm">
            <p>
                Type
                <b-select v-model="object" @change="set_column" :options="['Produit', 'Catégories']"></b-select> 
            </p>   
            <p> 
                Action
                <b-select @change="set_column" v-model="action" :options="['Récupérer', 'Récupérer avec les id du csv', 'Envoyer']"></b-select> 
            </p>

            <div v-show="action == 'Récupérer'">
                Conditions
                <div :id="'builder' + id"></div>
                <b-input v-model="conditions"></b-input>
            </div>

            <div v-if="action == 'Envoyer'">
                <b-checkbox style="display:inline-block" v-model="create">Créer</b-checkbox>&nbsp;&nbsp;
                <b-checkbox style="display:inline-block" v-model="update">Mettre à jour</b-checkbox>
            </div>

            <div v-if="action == 'Récupérer'">
                <b-checkbox style="display:inline-block" v-model="split_column">Split les colonnes</b-checkbox>&nbsp;&nbsp;
                <b-checkbox style="display:inline-block" v-model="split_line">Split les lignes</b-checkbox>
            </div>

            <div v-if="action == 'Récupérer avec les id du csv'">
                <b-checkbox style="display:inline-block" v-model="split_column">Split les colonnes</b-checkbox>
            </div>

            <p v-if="action.startsWith('Récupérer') && object == 'Produit'">
                Format des catégories
                <b-select v-model="categories_format" :options="[
                    { value: 'id', text: 'ID' },
                    { value: 'name', text: 'Nom' },
                    { value: 'object', text: 'Objet complet' }
                ]" />
            </p>

            <p v-if="action == 'Envoyer' && object == 'Produit'">
                <b-checkbox v-model="include_parent_categories">Inclure automatiquement les catégories parentes</b-checkbox>
            </p>

            <p>
                Mapping
                <b-container v-if="start" style="margin: 0; padding: 0; max-width: none;">
                    <b-row>
                        <b-col :cols="11"></b-col>
                        <b-col :cols="1" v-if="action != 'Récupérer'">
                            Identifiant
                        </b-col>
                    </b-row>
                    <b-row v-for="(value, key) in (object == 'Produit' ? mapping_product : mapping_category)" :key="key">
                        <b-col v-if="!value.languages && value.features === undefined && (action != 'Envoyer' || value.edit !== false)" :cols="2">
                            {{ value.name }}
                        </b-col>
                        <b-col v-if="!value.languages && value.features === undefined && (action != 'Envoyer' || value.edit !== false)" :cols="9">
                            <b-input :list="'columns' + id + key" v-model="value.column" />
                            <datalist :id="'columns' + id + key">
                                <option v-for="(option, idx) in columns_data" :key="'c' + idx">{{ option }}</option>
                            </datalist>      
                        </b-col>
                        <b-col v-if="!value.languages && value.features === undefined && (action != 'Envoyer' || value.edit !== false) && value.hasOwnProperty('identifiant') && action != 'Récupérer'" :cols="1">
                            <b-checkbox v-model="value.identifiant"></b-checkbox>
                        </b-col>
                        <!-- Bloc caractéristiques par colonne -->
                        <b-col v-if="value.features !== undefined && (action != 'Envoyer' || value.edit !== false)">
                            <b-container style="margin: 0; padding: 0; max-width: none;">
                                <b-row>
                                    <b-col :cols="2">{{ value.name }}</b-col>
                                    <b-col :cols="9">
                                        <b-input :list="'columns' + id + key" v-model="value.column" placeholder="Ou colonne JSON globale (optionnel)" />
                                        <datalist :id="'columns' + id + key">
                                            <option v-for="(option, idx) in columns_data" :key="'c' + idx">{{ option }}</option>
                                        </datalist>
                                    </b-col>
                                </b-row>
                                <b-row v-for="(feat, f_idx) in value.features" :key="'feat-' + f_idx">
                                    <b-col :cols="2">
                                        <div style="margin-left: 15px;">
                                            <b-input v-model="feat.feature_name" placeholder="Nom dans PrestaShop" />
                                        </div>
                                    </b-col>
                                    <b-col :cols="9">
                                        <b-input :list="'columns' + id + key + 'f' + f_idx" v-model="feat.column" />
                                        <datalist :id="'columns' + id + key + 'f' + f_idx">
                                            <option v-for="(option, idx) in columns_data" :key="'cf' + idx">{{ option }}</option>
                                        </datalist>
                                    </b-col>
                                    <b-col :cols="1">
                                        <b-button size="sm" variant="danger" @click="value.features.splice(f_idx, 1)">−</b-button>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1">
                                    <b-col>
                                        <b-button size="sm" @click="value.features.push({feature_name: '', column: ''})">+ Caractéristique</b-button>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-col>
                        <b-col v-if="value.languages">
                            <b-container style="margin: 0; padding: 0; max-width: none;">
                                <b-row>
                                    <b-col v-if="(action != 'Envoyer' || value.edit !== false)" :cols="2">
                                        {{ value.name }}
                                    </b-col>
                                    <b-col v-if="(action != 'Envoyer' || value.edit !== false)" :cols="9">
                                        <b-input :list="'columns' + id + key" v-model="value.column" />
                                        <datalist :id="'columns' + id + key">
                                            <option v-for="(option, idx) in columns_data" :key="'c' + idx">{{ option }}</option>
                                        </datalist>      
                                    </b-col>
                                </b-row>
                                <b-row v-for="(value, l_key) in value.languages" :key="l_key">
                                    <b-col :cols="2">
                                        <div style="margin-left: 15px;">{{ l_key }}</div>
                                    </b-col>
                                    <b-col :cols="9">
                                        <b-input :list="'columns' + id + key + l_key" v-model="value.column" />
                                        <datalist :id="'columns' + id + key + l_key">
                                            <option v-for="(option, idx) in columns_data" :key="'c' + idx + l_key">{{ option }}</option>
                                        </datalist>      
                                    </b-col>
                                    <b-col v-if="value.hasOwnProperty('identifiant') && action != 'Récupérer'" :cols="1">
                                        <b-checkbox v-model="value.identifiant"></b-checkbox>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </b-col>
                    </b-row>
                </b-container>
            </p>
        </div>
        <div v-else>
            Mise à jour
            <p>
                Type
                <b-select v-model="object" @change="set_column" :options="['Produits', 'Catégories', 'Annonces', 'Ventes']"></b-select> 
                Vérification de la marge
                <b-checkbox v-model="margin"></b-checkbox>
            </p>
        </div>
    </div>
</template>

<script>

    import $ from "jquery";
	import "../../../public/js/query-builder.default.min.css";
	import "../../../public/js/query-builder.min.js";
	import "../../../public/js/query-builder-fr.js";

    import uniqueId from "lodash.uniqueid";

    import store from "../../store.js";

    var clone = require("clone");
    
    export default {
        name: "splashsync",
		components: {
		},
		props: {
            treatment_params: {
                default: false
            },
            files: {
                default: () => []
            },
			data: {
				default: () => [],
            },
			client: {
				default: null
            },
            size: {
                default: 1000
            },
			step_position: {
				default: 0
			}
        },
        watch: 
        {
            columns_data: {
                deep: true,
                handler()
                {
                   //this.set_column()
                }
            },
            data: {
                deep: true,
                immediate: true,
                handler()
                {
                    if (this.data.length > 0)
                    {
                        this.columns_data = Object.keys(this.data[0]);
                    }
                }
            },
            files: {
                deep: true,
                immediate: true,
                handler()
                {
                    //console.log(this.files);

                    if (this.files.length > 0)
                    {
                        var self = this;
                        var reader = new FileReader();

                        reader.onload = (function (theFile) {
                            return function (e) {
                                if (e.target.result)
                                {
                                    var data = self.$papa.parse(e.target.result, { header: true });
                                    if (data.data && data.data.length > 0)
                                    {
                                        self.columns_data = Object.keys(data.data[0]);
                                    }
                                }
                            };
                        })(this.files[0].file ? this.files[0].file : this.files[0]);

                        reader.readAsText(this.files[0].file ? this.files[0].file : this.files[0]);
                    }
                }
            }
        },
        computed: {
            
        },
		data() {
			return {
                gm: false,
                start: false,
                create: true,
                update: true,
                languages: [],
                columns_data: [],
                id: uniqueId(""),
                object: "Produit",
                action: "Envoyer",
                split_column: false,
                split_line: false,
                conditions: "",
                rules_sql: "",
                rules_editor: "",
                margin: false,
                categories_format: "name",
                include_parent_categories: false,
                mapping_product: {
                    "id": {"name": "Id SMD", "column": "", "identifiant": false},
                    //"id_splash": {"name": "Id Splash Sync", "column": "", "identifiant": false},
                    "id_cms": {"name": "Id CMS", "column": "", "identifiant": false},
                    "reference": {"name": "Référence", "column": "", "identifiant": false},
                    "categories": {"name": "Catégories", "column": ""},
                    "default_category":{"name":"Catégorie principale","column":""},
                    "nom": {"name": "Nom", "column": "", "languages": {}},
                    "ean13": {"name": "Ean 13", "column": "", "identifiant": false},
                    //"upc": {"name": "UPC", "column": "", "identifiant": false},
                    "description_courte": {"name": "Description courte", "column": "", "languages": {}},
                    "description": {"name": "Description", "column": "", "languages": {}},
                    "caracteristiques": {"name": "Caractéristiques", "column": "", "features": []},
                    "images": {"name": "Images", "column": ""},
                    "date": {"name": "Date", "column": "", "edit": false},
                    "status": {"name": "Actif", "column": ""},
                    "prix_ht": {"name": "Prix ht", "column": ""},
                    "taxe_pourcentage": {"name": "Taxes - pourcentage", "column": ""},
                    "prix_ttc": {"name": "Prix ttc", "column": ""},
                    "prix_achat": {"name": "Prix achat", "column": ""},
                    "devise": {"name": "Devise", "column": "", "edit": false},
                    "prix_promo_ht": {"name": "Prix promo ht", "column": ""},
                    "prix_promo_ttc": {"name": "Prix promo ttc", "column": ""},
                    "date_promo_start": {"name": "Prix promo - début", "column": ""},
                    "date_promo_end": {"name": "Prix promo - fin", "column": ""},
                    "quantite": {"name": "Quantité", "column": ""},
                    "poids": {"name": "Poids", "column": ""},
                    "largeur": {"name": "Largeur", "column": ""},
                    "hauteur": {"name": "Hauteur", "column": ""},
                    "profondeur": {"name": "Profondeur", "column": ""},
                    "meta_title": {"name": "Meta - nom", "column": "", "languages": {}},
                    "meta_description": {"name": "Meta - description", "column": "", "languages": {}},
                    "meta_keywords": {"name": "Meta - mots clés", "column": "", "languages": {}},
                    "declinaisons": {"name": "Déclinaisons", "column": "", "table": "declinaisons"},
                    //"is_default_variant": {"name": "Est le variant par défaut", "column": "", "edit": true},
                    //"parent": {"name": "Paarent", "column": "", "edit": false},
                    //"parent_ref": {"name": "Parent ref", "column": "", "edit": true},
                    //"default_variant": {"name": "Variant par défaut", "column": "", "edit": false},
                    //"attributes": {"name": "Attributs", "column": "", "edit": true},
                    //"features": {"name": "Caractéristiques", "column": "", "edit": true}
                },
                mapping_category: {
                    "id": {"name": "Id SMD", "column": "", "identifiant": false},
                    //"id_splash": {"name": "Id Splash Sync", "column": "", "identifiant": false},
                    "id_cms": {"name": "Id CMS", "column": "", "identifiant": false},
                    "id_cms_parent": {"name": "Id CMS parent", "column": ""},
                    "nom": {"name": "Nom", "column": "", "languages": {}},
                    //"parent": {"name": "Catégorie parente", "column": ""},
                    "description": {"name": "Description", "column": "", "languages": {}},
                    //"additional_description": {"name": "Description complémentaires", "column": "", "languages": {}},
                    "link_rewrite": {"name": "URL simplifiée", "column": "", "languages": {}},
                    "meta_title": {"name": "Meta - nom", "column": "", "languages": {}},
                    "meta_description": {"name": "Meta - description", "column": "", "languages": {}},
                    //"meta_keywords": {"name": "Meta - mots clés", "column": "", "languages": {}},
                    "position": {"name": "Position", "column": ""},
                    "niveau": {"name": "Niveau", "column": "", "edit": false},
                }
			};
        },
        methods: {
            set_column()
            {
                var mapping = this.object == "Produit" ? this.mapping_product : this.mapping_category;
                var keys = Object.keys(mapping)
                for (var i = 0; i < keys.length; i++)
                {
                    if (!mapping[keys[i]].column)
                    {
                        if (this.columns_data.includes(mapping[keys[i]].name))
                            mapping[keys[i]].column = mapping[keys[i]].name;
                        else if (this.columns_data.includes(keys[i]))
                            mapping[keys[i]].column = keys[i];
                        else if (!mapping[keys[i]].languages && this.action != "Envoyer")
                            mapping[keys[i]].column = mapping[keys[i]].name;

                        if (mapping[keys[i]].languages && !mapping[keys[i]].column)
                        {
                            for (var j = 0; j < this.languages.length; j++)
                            {
                                if (this.columns_data.includes(mapping[keys[i]].name + " - " + this.languages[j]))
                                    mapping[keys[i]].languages[this.languages[j]].column = mapping[keys[i]].name + " - " + this.languages[j];
                                if (this.columns_data.includes(keys[i].name + " - " + this.languages[j]))
                                    mapping[keys[i]].languages[this.languages[j]].column = keys[i] + " - " + this.languages[j];
                                else if (this.action != "Envoyer")
                                    mapping[keys[i]].languages[this.languages[j]].column = mapping[keys[i]].name + " - " + this.languages[j];
                            }
                        }
                    }
                }

                this.setBuilder();
            },
            get_data()
            {
                return this.save()
            },
            save()
            {
                console.log("save");

                var data = {
                    object: this.object,
                    action: this.action,
                    conditions: this.conditions,
                    mapping: this.object == "Produit" ? this.mapping_product : this.mapping_category,
                    create: this.create,
                    update: this.update,
                    split_column: this.split_column,
                    split_line: this.split_line,
                    rules_editor: this.rules_editor,
                    rules_sql: this.rules_sql,
                    margin: this.margin,
                    categories_format: this.categories_format,
                    include_parent_categories: this.include_parent_categories
                }

                return data;
            },
            async load(data)
            {
                var self = this;
                
                if (!data)
                {
                    return;
                }

                console.log(clone(data))

                this.object = data.object;
                this.action = data.action;
                this.conditions = data.conditions;
                this.create = data.create;
                this.update = data.update;
                this.split_column = data.split_column;
                this.split_line = data.split_line;
                this.rules_editor = data.rules_editor || {};
                this.rule_sql = data.rule_sql;
                this.margin = data.margin || false;
                this.categories_format = data.categories_format || "id";
                this.include_parent_categories = data.include_parent_categories || false;
                if (this.object == "Produit")
                    this.mapping_product = data.mapping;
                else
                    this.mapping_category = data.mapping;

                this.setBuilder(clone(this.rules_editor));
            },
            setBuilder(rules_editor)
            {
				var id = this.id;
                var mapping = this.mapping_product;
                var self = this;

                try {
					$("#builder" + id).queryBuilder("destroy");
					self.rules_sql = "";
				} catch (err) {}

                var columns = [];

                if (this.client.details.splash && this.client.details.splash.languages)
                    this.languages = this.client.details.splash.languages;

                var keys = Object.keys(mapping)
                for (var i = 0; i < keys.length; i++)
                {
                    if (mapping[keys[i]].languages)
                    {
                        for (var j = 0; j < this.languages.length; j++)
                        {
                            columns.push({
                                id: keys[i] + "->>'$." + this.languages[j] + "'",
                                label: mapping[keys[i]].name + " - " + this.languages[j],
                                type: "string",
                            })
                        }
                    }
                    else
                    {
                        columns.push({
                            id: "`" + keys[i] + "`",
                            label: mapping[keys[i]].column || keys[i],
                            type: mapping[keys[i]].type || "string",
                        })
                    }
                }

                var config = {
					filters: columns,
					icons: {
						add_group: "fas fa-plus-square",
						add_rule: "fas fa-plus-circle",
						remove_group: "fas fa-minus-square",
						remove_rule: "fas fa-minus-circle",
						error: "fas fa-exclamation-triangle",
					},
					operators: [
						{ type: "equal" },
						{ type: "not_equal" },
						{ type: "less" },
						{ type: "less_or_equal" },
						{ type: "greater" },
						{ type: "greater_or_equal" },
						{ type: "between" },
						{ type: "contains" },
						{ type: "not_contains" },
						{ type: "begins_with" },
						{ type: "ends_with" },
						{
							type: "is_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
						{
							type: "is_not_empty",
							apply_to: [
								"string",
								"number",
								"datetime",
								"boolean",
							],
						},
					],
				};
            
                $("#builder" + id).queryBuilder(config);

				$("#builder" + id).on(
					"change",
					function (e, rule, error, value) {
						try {
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							self.rules_editor = $("#builder" + id).queryBuilder(
								"getRules"
							);
							self.rules_sql = self.rules_sql;
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` = ''/gi,
								"(`$1` = '' or `$1` is NULL)"
							);
							self.rules_sql = self.rules_sql.replace(
								/`([^`]*)` != ''/gi,
								"(`$1` != '' and `$1` is not NULL)"
							);
							//console.log(self.rules_sql)
							//self.updatePage();
						} catch (err) {
							self.rules_sql = "";
						}
					}
				);

				$("#builder" + id).on(
					"afterDeleteRule.queryBuilder",
					function (e, rule, error, value) {
						try {
							self.rules_editor = $("#builder" + id).queryBuilder(
								"getRules"
							);							
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
							//self.updatePage();
						} catch (err) {
							self.rules_sql = "";
							self.rules_editor = "";
						}
					}
				);
				$("#builder" + id).on(
					"afterDeleteGroup.queryBuilder",
					function (e, group) {
						try {
							self.rules_editor = $("#builder" + id).queryBuilder(
								"getRules"
							);
							self.rules_sql = $("#builder" + id).queryBuilder(
								"getSQL",
								false
							).sql;
						} catch (err) {
							self.rules_sql = "";
							self.rules_editor = "";
						}
					}
				);
                if (rules_editor)
				{
                    console.log("rules_editor")
                    console.log(rules_editor)
					try {
						$("#builder" + this.id).queryBuilder(
							"setRules",
							rules_editor
						);
					} catch (err) {
					}
				}
            }
        },
        async mounted()
        {

            // etape prestashop

            this.languages = ["fr_FR"]
            if (this.client.details.splash && this.client.details.splash.languages)
                this.languages = this.client.details.splash.languages;
            if (this.client.details.prestashop && this.client.details.prestashop.languages)
                this.languages = this.client.details.prestashop.languages;

            var keys = Object.keys(this.mapping_product)
            for (var i = 0; i < keys.length; i++)
            {
                if (this.mapping_product[keys[i]].languages)
                {
                    for (var j = 0; j < this.languages.length; j++)
                    {
                        this.mapping_product[keys[i]].languages[this.languages[j]] = {
                            "name": this.languages[j], 
                            "column": ""
                        }

                        if (keys[i] == "nom")
                            this.mapping_product[keys[i]].languages[this.languages[j]]["identifiant"] = false;
                    }
                }
            }
            var keys = Object.keys(this.mapping_category)
            for (var i = 0; i < keys.length; i++)
            {
                if (this.mapping_category[keys[i]].languages)
                {
                    for (var j = 0; j < this.languages.length; j++)
                    {
                        this.mapping_category[keys[i]].languages[this.languages[j]] = {
                            "name": this.languages[j], 
                            "column": ""
                        }

                        if (keys[i] == "nom")
                            this.mapping_category[keys[i]].languages[this.languages[j]]["identifiant"] = false;
                    }
                }
            }

            this.start = true;

            this.set_column();

            var client = store.getters.getClient;
            if (client && client.details && client.details.prestashop && client.details.prestashop.structure == "gm")
                this.gm = true;
        }
    }
</script>

<style scoped>
</style>